export class CamRecord<TData extends { [key: string]: any } = { [key: string]: any }> {
  public data: TData;

  public id: string | number;

  constructor(data?: TData) {
    this.data = { ...((data ?? {}) as TData) };
    this.id = this.data['id'];
  }

  public getData(field: string): any {
    return this.data[field];
  }

  public setData(field: string | { [key: string]: any }, value?: any): void {
    if (typeof field === 'string') {
      (this.data as { [key: string]: any })[field] = value;
    } else {
      Object.entries(field).forEach(([key, entryValue]) => {
        (this.data as { [key: string]: any })[key] = entryValue;
      });
    }
    this.id = this.data['id'];
  }

  public toJSON(): TData {
    return { ...this.data };
  }
}
